import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Field from '../../../../../../../components/Form/Field'

import { formatCurrency } from '../../../../../../../helpers/numbers'

import { selectedFacebookAdAccountSelector } from '../../../../../../../modules/selectors/adAccounts'

import { CAMPAIGN_BUDGET } from '../../../../../../Multiplatform/CampaignForms/fields'
import { BUDGET_DAILY, BUDGET_LIFETIME } from '../../../../../../Multiplatform/fields'

const BudgetContent = ({ formik, budgetType, campaignBudgetLifetime, campaignBudgetDaily }) => {
  const { t } = useTranslation()

  const { currency_symbol } = useSelector(selectedFacebookAdAccountSelector)

  if (budgetType === CAMPAIGN_BUDGET) {
    const formattedCampaignBudgetLifetime = formatCurrency(
      campaignBudgetLifetime,
      { min: 2, max: 2 },
      { symbol: currency_symbol }
    )

    const formattedCampaignBudgetDaily = formatCurrency(
      campaignBudgetDaily,
      { min: 2, max: 2 },
      { symbol: currency_symbol }
    )

    const budgetTypeMessage = campaignBudgetLifetime ? 'lifetime' : 'daily'
    const budgetValue = campaignBudgetLifetime ? formattedCampaignBudgetLifetime : formattedCampaignBudgetDaily

    return (
      <>
        <p>{`${t(`There is a campaign ${budgetTypeMessage} budget of`)} ${budgetValue}. ${t(
          'This will be allocated across ad sets based on performance.'
        )}`}</p>
        <p>{t('If you want to edit this budget, edit the campaign.')}</p>
      </>
    )
  }

  if (budgetType === BUDGET_LIFETIME) {
    return (
      <Field
        type="number"
        formik={formik}
        name={BUDGET_LIFETIME}
        placeholder={t('Lifetime Budget')}
        symbol={currency_symbol}
        autoComplete="off"
      />
    )
  }

  if (budgetType === BUDGET_DAILY) {
    return (
      <Field
        type="number"
        formik={formik}
        name={BUDGET_DAILY}
        placeholder={t('Daily Budget')}
        symbol={currency_symbol}
        autoComplete="off"
      />
    )
  }

  return null
}

export default BudgetContent
